Directives.SvgLogoHbDirective = function SvgLogoHbDirective() {

    //@ngInject
    function SvgLogoHbDirectiveControllerFunc($scope, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SvgLogoHbDirectiveController';

        this.fillColor = null;
        if (this.color) {
            this.fillColor = this.color;
        } else {
            this.fillColor = '#787878';
        }
    }

    var SvgLogoHbDirectiveController = Class(Controllers.BaseController, {
        constructor: SvgLogoHbDirectiveControllerFunc
    });

    return {
        restrict: 'E',
        scope: {
            color: '@?'
        },
        templateUrl : 'angular/app/modules/common/svgs/logo_hb/svg_logo_hb_directive_template.html',
        controller: SvgLogoHbDirectiveController,
        controllerAs: 'svgLogoHbVm',
        bindToController: true
    };
};
